<template>
  <div class="modal fade in mypopup" id="about" tabindex="-1" role="dialog" aria-hidden="false">
    <div class="modal-dialog modal-lg">
      <!-- Modal content-->
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal"><img src="../assets/cross.png"></button>
        <h1 class="f black"> About Tiberias </h1>
        <p>
        In the tenth century the sages of Tiberias concluded an unprecedented scrutiny of every word and letter of the Hebrew Bible, producing the Masoretic Text. In a nod to their spirit, Tiberias ushers in a new age of unprecedented and meticulous examination of the Hebrew Bible.
        </p>
        <p>
        Under the direction of Moshe Koppel (Computer Science, Bar-Ilan University) and Joshua Berman (Hebrew Bible, Bar-Ilan University), Tiberias marshals cutting edge advances in the field of machine learning and computational linguistics to empower users to easily conduct their own experiments analyzing and classifying the texts of the Hebrew Bible through the measurable features of linguistic data, and providing them with verifiable results.
        </p>
        <p>
        For its analyses, Tiberias employs the Hebrew Bible database of the Eep Talstra Centre for Bible and Computer
        <a href="https://www.godgeleerdheid.vu.nl/en/research/institutes-and-centres/eep-talstra-centre-for-bible-and-computer/index.aspx" target="_blank">
        (https://www.godgeleerdheid.vu.nl/en/research/institutes-and-centres/eep-talstra-centre-for-bible-and-computer/index.aspx).
        The ETCBC IV database is unparalleled in its systematic tagging of linguistic information at the word, phrase and clause level.
        </a>
        </p>
        <p>
        Tiberias is a product of Dicta
        <a href="http://dicta.org.il" target="_blank">
        (http://dicta.org.il),
        </a>
        a non-profit organization that has developed a range of tools that employ machine learning and natural language processing for the analysis of Hebrew texts.  Dicta provides its products at no charge in the spirit of free and open inquiry.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'howPopup',
  data () {
    return {
    }
  }
}
</script>
<style scoped>
.mypopup {
  overflow: hidden;
}
.modal {
  text-align: center;
  padding: 0!important;
  z-index: 999999;
}
.modal-dialog{
  padding: 35px 56px 20px;
  width: 548px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 4px 4px 6px 0 rgba(0, 0, 0, 0.32);
  text-align: left;
}
.modal-content{
  border:none;
  box-shadow:none;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px; /* Adjusts for spacing */
}

.modal-dialog {
  display: inline-block;
  vertical-align: top;
  margin: 75px auto 0;
}
.mypopup p {
  font-size: 14px;
  line-height: 20px;
  margin: 0 0 15px;
  color: #000;
}

.mypopup h1 {
  margin:0 0 14px;
}
.mypopup .close {
  position: absolute;
  top: -75px;
  left: -55px;
  padding: 0;
  cursor: pointer;
  opacity:1;
  outline: none !important;
  box-shadow: none;
}

.header-popup{
  position: absolute;
  top:0;
  left: 0;
  right:0;
  z-index: 100;
  padding: 10px 42px 7px;
  background-color: #007ee5;
  border-radius: 4px 4px 0 0;
}

#detail .modal-dialog{
  text-align: right;
  padding: 52px 0 0;
  height: 80%;

}
#detail .modal-content{
  overflow-y: scroll;
  padding: 0 15px 20px 15px;
  height: 100%;
}
.mypopup h2{
  font-size: 18px;
  line-height: 21px;
  font-family: 'Arimo';
}
#detail.mypopup p{
  font-size: 17px;
  line-height: 27px;
  font-family: "Times New Roman";
}
#detail .link{
  font-size: 12px;
  line-height: 15px;
  text-decoration: none;
  margin: 2px 0 0 -13px;
  font-family: 'Arimo';
  border-bottom:1px solid #fff;
  position: relative;
}
#detail .link:after{
  width: 9px;
  height: 11px;
  position: absolute;
  top: 2px;
  right: -15px;
  content: "";
  background: url("../assets/copy-icon.png") no-repeat;
}
#detail.mypopup .close{
  left: auto;
  right: 2px;
  top: -38px;
}

</style>



// WEBPACK FOOTER //
// src/components/howPopup.vue